import React, { useRef, useState } from 'react';
import { FadeIn } from './FadeIn';
import { PlayArrow } from '@mui/icons-material';
const VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/4GG24EADc1uVDoAw8VGi8G/VN20261007_151034.mp4';
const POSTER_URL = 'https://cdn.magicpatterns.com/uploads/gdoNaevVERZnpGkuzwxwbb/WhatsApp_Image_2026-04-05_at_18.28.17_(1).jpg';
export function AlbumVideoSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [started, setStarted] = useState(false);
  const handlePlay = () => {
    setStarted(true);
    // Wait for the video element to receive its src before playing
    requestAnimationFrame(() => {
      videoRef.current?.play().catch(() => undefined);
    });
  };
  return <section className="py-10 bg-brand-50" aria-labelledby="album-video-title" data-id="element-14" data-mp="5gah22w211uj">
      <div className="container mx-auto px-4" data-id="element-15" data-mp="1bwcpmhhqueky">
        <div className="max-w-md mx-auto text-center" data-id="element-16" data-mp="1bvkzhm6x1922">
          <FadeIn data-id="element-17" data-mp="1guo10wnosx5a">
            <span className="text-brand-600 font-bold tracking-wider uppercase text-sm mb-1 block" data-id="element-18" data-mp="1gu4m7otc2ovh">
              Mirá cómo es por dentro 👀
            </span>
            <h2 id="album-video-title" className="text-2xl md:text-3xl font-bold text-slate-900 mb-6" data-id="element-19" data-mp="2lyy1pws3ghxn">
              Así es el álbum por dentro 📖
            </h2>
          </FadeIn>

          <FadeIn delay={0.1} data-id="element-20" data-mp="2cz2ntk75m8tx">
            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-900 aspect-[9/16] max-h-[70vh] mx-auto" data-id="element-21" data-mp="2cxrihfy28t0p">
              <video ref={videoRef} src={started ? VIDEO_URL : undefined} poster={POSTER_URL} preload="none" playsInline controls={started} controlsList="nodownload" className="w-full h-full object-cover" aria-label="Video del álbum 100 Citas por dentro" data-id="element-22" data-mp="238q3nt394hob" />
              {!started && <button type="button" onClick={handlePlay} className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-slate-900/40 hover:bg-slate-900/30 transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-brand-400" aria-label="Reproducir video" data-id="element-23" data-mp="1ka43qhjh0wlz">
                  <span className="w-20 h-20 rounded-full bg-brand-500 flex items-center justify-center shadow-2xl transition-transform hover:scale-110" data-id="element-24" data-mp="15nyav09f5leb">
                    <PlayArrow sx={{
                  fontSize: 48,
                  color: 'white'
                }} data-id="element-25" data-mp="1ybkrb93qwkil" />
                  </span>
                  <span className="text-white font-bold text-lg drop-shadow" data-id="element-26" data-mp="1ydf0jq5nmo6u">
                    Ver el álbum por dentro
                  </span>
                </button>}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}